import { useStorage, useStorageDownloadURL } from 'reactfire';
import { ref } from "firebase/storage";

function useImageUrl(url) {
  const storage = useStorage();
  const imageRef = ref(storage, url);
  return useStorageDownloadURL(imageRef);
}

export default useImageUrl;